// E-Editions (left rail, admin only — 2026-10-28; was an Admin Review tab). Upload an edition for any
// paper, set each paper's ecore / FlipHTML5 workflow, and follow every run. Backend: src/eedition.js.
import EEditionsPanel from "../components/EEditionsPanel";
import useIsMobile from "../hooks/useIsMobile";

export default function EEditions() {
  const isMobile = useIsMobile();
  return (
    <div style={{ padding: isMobile ? 14 : 24, maxWidth: 1400, width: "100%", minWidth: 0, boxSizing: "border-box", margin: "0 auto" }}>
      <div style={{ marginBottom: 16 }}>
        <h1 style={{ margin: 0, fontSize: 22, fontWeight: 800, color: "var(--t-text-primary)" }}>E-Editions</h1>
        <div style={{ fontSize: 13, color: "var(--t-text-faint)", marginTop: 3 }}>Upload editions, set up each paper's e-edition and flipbook, and follow every run.</div>
      </div>
      <EEditionsPanel />
    </div>
  );
}
